module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Trash-48cc7a5e006e01033cfcb36d25c33de46c54d25607ebf9eae5da886c37eaba05.svg";